import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { AccessTokenInterceptor } from './access-token.interceptor'
import { RefreshTokenCommand } from './commands/refresh-token.command'
import { FailedRequestsInterceptor } from './failed-requests.interceptor'
import { RefreshTokenInterceptor } from './refresh-token.interceptor'

export const httpInterceptorProviders = [
  RefreshTokenCommand,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AccessTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RefreshTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: FailedRequestsInterceptor,
    multi: true,
  },
]
